import { Inject, Injectable } from '@angular/core';
import { DataService } from '../http/dataService';
import { ENV, IEnvironment } from 'env/config';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { Service } from '../entity';
import { CentralApis } from '../interfaces/internal';
import { AddressHistory } from '../models/addressHistory.model';
import { Repository } from './repository';
import { Result } from '../interfaces/helpers';

@Service({
  api: 'address',
  model: AddressHistory,
})
@Injectable({ providedIn: 'root' })
export class AddressHistoryRepository extends Repository<AddressHistory> {
  constructor(@Inject(ENV) env: IEnvironment, dataService: DataService) {
    super({
      client: dataService,
      url: (env.api.backend.central.endpoint as CentralApis).activity,
    });
  }

  getAll(queryString?: any): Observable<Result<AddressHistory>> {
    return super.getAll<AddressHistory>(queryString);
  }

  createFromDTO(item): AddressHistory {
    return new AddressHistory({ ...item, date: new Date(item.date) });
  }
}
